"use strict";

import React, {Component} from "react";
import {PropTypes} from "Subschema";
import UIPropTypes from "../PropTypes";

export default class Notification extends Component {

    static displayName = 'Notification';

    static propTypes = {
        message: UIPropTypes.notif,
        styleClass: PropTypes.style,
        notificationType: PropTypes.string,
        transition: PropTypes.transition
    };
    static defaultProps = {
        styleClass: "Notification",
        "transition": "rollUp"
    };

    renderNotification(notification, i) {
        const { styleClass } = this.props;
        const __html = `<span class = "${styleClass.msgContainer}"> ${notification.message} </span>`;
        return <p key={`global_notif-p-${i}`} className={this.props.messageClass} dangerouslySetInnerHTML={{__html: __html}}></p>;
    }

    renderContent() {
        const {message, transition, containerClass, boxClass, notificationType, styleClass} = this.props;
        return (
            <div className={containerClass}>
                <div className={`${boxClass} ${styleClass[notificationType]}`}>
                    {message.map(this.renderNotification, this)}
                </div>
            </div>);
    }

    render() {
        const {message, transition} = this.props;
        const {Transition, ...transprops} = transition;
        return (<Transition {...transprops}>
            {message ? this.renderContent() : null}
        </Transition>);
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/Notification.jsx
 **/